import React from 'react';

import store from 'redux/store';
import { actionCreators as accountActions } from 'redux/accountHandlers';
import { appConfig } from 'config/customization';

import UserWithoutAccounts from './components/UserWithoutAccounts';
import AccountsError from './components/AccountsError';

const handleReloadAccounts = async () => {
  const userId = store.getState().auth.currentUser.id;
  await store.dispatch(accountActions.getAccountsAsync(userId));
};

const WithoutAccounts = ({ shouldShowMessage, accountsError }) => WrappedComponent => {
  const WithoutAccountsContainer = childrenProps =>
    accountsError(childrenProps) ? (
      <AccountsError onReload={handleReloadAccounts} errorMessage={accountsError(childrenProps)} />
    ) : shouldShowMessage(childrenProps) && appConfig.canUseDashboardWithoutAccounts ? (
      <UserWithoutAccounts />
    ) : (
      <WrappedComponent {...childrenProps} />
    );
  return WithoutAccountsContainer;
};

export default WithoutAccounts;
